import { defineComponent as _defineComponent } from 'vue'
import RmpBtn from "@rmp/core/components/buttons/RmpBtn.vue";
import RmpTextField from "@rmp/core/components/fields/RmpTextField.vue";
import { RouteNames } from "@rmp/id/router/routes";
import { requiredRule } from "@rmp/core/utils/validation";
import { validatePersonInn, validateLegalEntityInn } from "@rmp/core/utils/validator";
import RmpSignInFormBase from "@rmp/core/components/form/RmpSignInFormBase.vue";
import { useI18n } from "vue-i18n-composable";
import { useRoute } from "vue-router/composables";
import { useColors } from "@rmp/core/composables/useColors";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useForm } from "@rmp/core/composables/useForm";
import { useSignInStore } from "@rmp/id/stores/signIn";
import RmpTextBtn from "@rmp/core/components/buttons/RmpTextBtn.vue";
import { captchaEnabled } from "@rmp/core/services/captcha";
import RmpCaptcha from "@rmp/core/components/fields/RmpCaptcha.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpSignIn',
  setup(__props) {

const { tc } = useI18n();
const route = useRoute();
const { colors } = useColors();

const useStore = useSignInStore;
const store = useStore();
const { save, initialize } = store;
const { user, captchaToken } = storeToRefs(store);

const isPasswordVisible = ref(false);

const validation = {
	login: [requiredRule()],
	password: [requiredRule()]
};

const {
	form,
	formStateLoading,
	formReadonly,
	formDisabled,
	formSaving,
	formValid,
	submit
} = useForm({ useStore }, true);

const isInn = (login) => {
	return validatePersonInn(login) || validateLegalEntityInn(login);
};

initialize();

return { __sfc: true,tc, route, colors, useStore, store, save, initialize, user, captchaToken, isPasswordVisible, validation, form, formStateLoading, formReadonly, formDisabled, formSaving, formValid, submit, isInn, RmpBtn, RmpTextField, RouteNames, RmpSignInFormBase, RmpTextBtn, captchaEnabled, RmpCaptcha }
}

})